
import Layout from "@/components/Layout";
import HomeContent from "@/components/home/HomeContent";

const Index = () => {
  return (
    <Layout>
      <HomeContent />
    </Layout>
  );
};

export default Index;
